export const getBaseApiUrl = () => {
  // return "http://localhost:8080";
 // return "https://asa-mco-sys-00-nemcis.private.azuremicroservices.io";
  //  return "https://sys-nemcis-dhhs.nebraska.gov";
  return "https://nemcis-dhhs.nebraska.gov";
}


export const downloadFileToken = () => {
  return '?sv=2024-11-04&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2030-05-23T21:16:56Z&st=2025-04-14T13:16:56Z&spr=https&sig=YEJMdRiBMmwKz1loSKbZ0jbsImbg11hlQwMJWVU3biA%3D';
}


export const getB2CRedirectSignInUrl = () => {

  const b2c_client_id = process.env.REACT_APP_B2C_CLIENT_ID;
  const b2c_tenant = process.env.REACT_APP_B2C_TENANT_ID;
  const b2c_policy_name = process.env.REACT_APP_B2C_POLICY_NAME;
  const b2c_redirect_uri = process.env.REACT_APP_B2C_REDIRECT_URI;
  const b2c_client_secret = process.env.REACT_APP_B2C_CLIENT_SECRET;

  const signInUrl = `https://${b2c_tenant}.b2clogin.com/${b2c_tenant}.onmicrosoft.com/oauth2/v2.0/authorize?p=${b2c_policy_name}&client_id=${b2c_client_id}&nonce=defaultNonce&redirect_uri=${b2c_redirect_uri}&scope=openid ${b2c_client_id}&response_type=code&isMFA=true`;
  return signInUrl;  
}

export const getB2CRedirectLogoutUrl = () => {
  
  const b2c_client_id = process.env.REACT_APP_B2C_CLIENT_ID;
  const b2c_tenant = process.env.REACT_APP_B2C_TENANT_ID;
  const b2c_policy_name = process.env.REACT_APP_B2C_POLICY_NAME;
  const b2c_redirect_uri = process.env.REACT_APP_B2C_REDIRECT_URI;
  const b2c_client_secret = process.env.REACT_APP_B2C_CLIENT_SECRET;

  const logoutUrl = `https://${b2c_tenant}.b2clogin.com/${b2c_tenant}.onmicrosoft.com/oauth2/v2.0/logout?p=${b2c_policy_name}&client_id=${b2c_client_id}&post_logout_redirect_uri=${b2c_redirect_uri}`;
  return logoutUrl;  
}

export const getB2CGroupUrl = () => {
  const b2c_groups_url = 'https://getsharedgroups.azurewebsites.net/api/b2cprdgetgroup?code=nZUNYFCBepK7UjifDljsDDn-aJS-UWokVbvvo3apTvCOAzFuQ5mWuA==';
  return b2c_groups_url;
}